var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcSettingsSection,{attrs:{"name":_setup.t('files', 'Files')}},[_c(_setup.TransferOwnershipDialogue)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }